// Seller Services
// Helpers
import {isServer} from '@adv-mt/mt-utils'

import AdsEntitiesFactory from '../../ads/Entities/factory.js'
import DealerServicesFactory from '../../dealer/Services/factory.js'
// Other context Factories
import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
// Seller Factories
import {SellerErrorsFactory} from '../Errors/factory.js'
import {SellerRepositoriesFactory} from '../Repositories/factory.js'
import {SellerValueObjectsFactory} from '../ValueObjects/factory.js'
import {GetInstantOfferByAdSellerService} from './GetInstantOfferByAdSellerService.js'
import {GetLastContactDetailsSellerService} from './GetLastContactDetailsSellerService.js'
import {GetSellerService} from './GetSellerService.js'
import {SaveContactDetailsSellerService} from './SaveContactDetailsSellerService.js'

export class SellerServicesFactory {
  static saveContactDetailsSellerService = ({config}) =>
    new SaveContactDetailsSellerService({
      sellerRepository: isServer
        ? SellerRepositoriesFactory.emptySellerRepository()
        : SellerRepositoriesFactory.localStorageSellerRepository({config})
    })

  static getLastContactDetailsSellerService = ({config}) =>
    new GetLastContactDetailsSellerService({
      sellerRepository: isServer
        ? SellerRepositoriesFactory.emptySellerRepository()
        : SellerRepositoriesFactory.localStorageSellerRepository({config})
    })

  static getSellerService = ({config}) =>
    new GetSellerService({
      config,
      getDealerService: DealerServicesFactory.getDealerService({config}),
      getUserService: UserServicesFactory.getUserService({config}),
      sellerValueObjectFactory: SellerValueObjectsFactory.sellerValueObject
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetInstantOfferByAdSellerService}
   * @property {Service} getUserService
   * @property {RequestFactory} getInstantOfferRequestFactory
   * @property {HTTPAdsRepository} repository
   */
  static getInstantOfferByAdSellerService = ({config}) =>
    new GetInstantOfferByAdSellerService({
      adsEntityFactory: AdsEntitiesFactory.adEntity,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      invalidRequestErrorFactory: SellerErrorsFactory.invalidRequestSellerError,
      repository: SellerRepositoriesFactory.hTTPSellerRepository({config}),
      userNotLoggedInErrorFactory: UserErrorsFactory.userNotLoggedInUserError
    })
}
